<template>
    <v-dialog
      content-class="dialogText"
            v-model="isDialog"
            style="z-index: 600;"
            max-width="400"
            :light="true"
    >
        <v-card v-if="isDialog">
            <div class="absX" @click.passive="closeDialog">
                <v-icon x-large class="myGray">mdi-window-close</v-icon>
            </div>
            <div class="spacer-25"></div>
            <v-card-title class="headline">Teile die App mit deinen Freunden!</v-card-title>

            <!--            v-on:submit.prevent-->
            <!--            form is required to react on virtual keyboard done event-->
            <!--            <v-card-text class="text-center hide-xs">-->
            <!--                Zeig den QR-Code deinen Freunden, damit diese auch die App benutzen können:-->
            <!--            </v-card-text>-->

<!--            <div class="text-center">-->
<!--                &lt;!&ndash;                <div id="placeHolder"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                <div>&ndash;&gt;-->
<!--                                    <div class="qrCode">-->
<!--                                        <img src="../assets/qr-1.png">-->
<!--                                    </div>-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                <div class="url">{{appUrl}}</div>-->

<!--            </div>-->

            <div class="text-center">
                <!--                <div id="placeHolder"></div>-->
                <div>
                    <div class="qrCode" :inner-html.prop="qrCodeData"></div>
                                    </div>

                <div class="url">{{appUrl}}</div>

            </div>

            <v-card-actions class="text-center justify-center">
                <v-btn class="okBtn rounded100" large text @click="ok">OK</v-btn>
            </v-card-actions>
            <div class="pb-3"></div>

        </v-card>
    </v-dialog>
</template>

<script>
    import store from '../store/store'
    // import * as firebaseUtil from '../firebase/firebaseUtil'
    import {qrcode} from "../others/qrcode";
    // import * as bootstrap from '../vendor/bootstrap';
    // import {qrqsCode} from "../vendor/qconstants";

    export default {
        props: {
            dialog: Boolean,
        },
        data() {
            return {
                isDialog: false,

                qrCodeData: '',

                shareUrl: ''
            }
        },

        // beforeCreate(){
        //     util.enableNoScroll(true)
        // },
        // beforeDestroy(){
        //     util.enableNoScroll(false)
        // },

        computed: {
            appUrl() {
                return 'https://' + window.location.hostname + '/';
            },
        },

        watch: {
            dialog(newValue) {
                this.isDialog = newValue;
                if (newValue) {
                    setTimeout(() => {
                        this.init();
                    }, 200);
                    setTimeout(() => {
                        this.share();
                    }, 600);
                }
            },
            isDialog(newValue) {
                if (!newValue) {
                    // this.ready = false;
                    this.$emit('close');
                }
            },
        },

        methods: {
            closeDialog() {
                this.isDialog = false;
            },

            init() {
                //generate invitation URL
                let url = this.appUrl;
                // let user = firebaseUtil.getUser();
                // let rPrograms = store.getters.referralPrograms;
                // if (user && rPrograms && rPrograms.length > 0) {
                //     let rp = rPrograms[0];
                //     //	programId: 'x2referral',
                //     //amountForReferrer:2,
                //     //    amountForFriend: 3
                //     //?referrer=[fuid]&rpId=x2referral&referrerName=Dieter&amountForFriend=4
                //     let queryParams = '?referrer=' + user.uid + '&ruid=' + uid + '&rpId=' + rp.programId
                //         + '&referrerName=' + encodeURIComponent(user.displayName)
                //         + '&amountForFriend=' + rp.amountForFriend;
                //     url = url + queryParams;
                //     // } else {
                //     // if (store.state.shortUrl.length > 0) {
                //     //     url = '' + store.state.shortUrl;
                //     // }
                    // } else {
                //     url ='https://' + window.location.hostname + '/?bivtr=' + uid ;//+ '#/Registrierung';
                    // }
                this.shareUrl = url;


                if (this.qrCodeData.length === 0) {
                    let typeNumber = 0;
                    let errorCorrectionLevel = 'M';
                    let qr = qrcode(typeNumber, errorCorrectionLevel);
                    qr.addData(this.shareUrl);
                    qr.make();
                    // document.getElementById('placeHolder').innerHTML = qr.createImgTag();
                    let cellSize = 5;
                    this.qrCodeData = qr.createImgTag(cellSize);
                }
            },

            ok() {
                this.closeDialog();
            },

            share() {
                let title = store.state.brandName;
                let text = 'Zur App von ' +store.state.brandName;

                // let user = firebaseUtil.getUser();
                // if (user) {
                //     text = 'Sichere dir jetzt Coupons für ' + store.state.brandName;
                //     // + sichern! '+user.displayName+' lädt dich ein, die Bestell-App für ' +store.state.brandName+' zu probieren!';
                // }

                try {
                    window.navigator.share({
                        title: title,
                        text: text,
                        url: this.shareUrl,
                    }); // share the URL of MDN
                } catch (e) {
                    console.log('Error in shareApp: ' + e.message);
                    //use email instead
                    let body = 'Hier geht es zur App von ' + store.state.brandName + ':\n \n' +
                        // 'Jetzt App oder Webseite öffnen, um auf dem Laufenden zu bleiben:  \n \n' +
                    // let body = 'Heute Backwaren bestellen und Morgen abholen mit der neuen Bestell-App von ' + store.state.brandName + '!\n \n' +
                    //     'Jetzt Webseite oder App öffnen und auf dem Laufenden bleiben:  \n \n' +
                        this.appUrl;
                    // if (user && store.getters.referralPrograms.length > 0) {
                    //     body = user.displayName + ' lädt dich ein, die neue App für ' +
                    //         store.state.brandName + ' zu nutzen. Als Belohnung für diese Einladung erhälst du einen Gutschein im Wert von ' +
                    //         store.getters.referralPrograms[0].amountForFriend + ',00 € für deine erste Bestellung! \n \n' +
                    //         'Jetzt registrieren und sofort sparen:  \n \n' +
                    //         this.shareUrl;
                    // }
                    body = encodeURIComponent(body);
                    text = encodeURIComponent(text);
                    let mailto_link = 'mailto:?subject=' + text + '&body=' + body;
                    let win = window.open(mailto_link);//, '_blank');
                    win.focus();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .qrCode {
        width: 250px;
        height: 250px;
        display: inline-block;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .url {
        font-size: 1.2em;
        font-weight: bold;
    }

    /*.vvd{*/
    /*    >>> .v-dialog{*/
    /*        position: absolute;*/
    /*    }*/
    /*}*/
</style>
